export default __webpack_public_path__ + "resources/icons/n432-c221.png";